var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.437771 0.476694C0.718439 0.196965 1.0989 0.0398433 1.49558 0.0398433C1.89225 0.0398433 2.27271 0.196965 2.55338 0.476694L8.98004 6.88984L15.4067 0.476694C15.5897 0.280068 15.8224 0.136327 16.0803 0.0606161C16.3383 -0.0150952 16.612 -0.0199736 16.8725 0.0464945C17.133 0.112963 17.3707 0.248316 17.5606 0.438295C17.7505 0.628274 17.8855 0.865844 17.9514 1.12598C18.0179 1.38565 18.0131 1.65839 17.9376 1.9156C17.8621 2.17281 17.7187 2.40501 17.5223 2.58786L11.0956 9.001L17.5223 15.4142C17.7193 15.5967 17.8634 15.829 17.9393 16.0864C18.0151 16.3438 18.02 16.6169 17.9534 16.8768C17.8868 17.1368 17.7512 17.374 17.5608 17.5635C17.3704 17.753 17.1323 17.8877 16.8717 17.9535C16.6114 18.0199 16.3381 18.0151 16.0804 17.9398C15.8226 17.8644 15.5899 17.7213 15.4067 17.5253L8.98004 11.1122L2.55338 17.5253C2.26968 17.7895 1.89426 17.9334 1.50628 17.9267C1.1183 17.92 0.748086 17.7633 0.473697 17.4895C0.199321 17.2157 0.042219 16.8462 0.0355169 16.4591C0.0288148 16.0719 0.173036 15.6973 0.437771 15.4142L6.86443 9.001L0.437771 2.58786C0.157452 2.30778 0 1.92812 0 1.53227C0 1.13643 0.157452 0.756773 0.437771 0.476694Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/closeX.0edb478e6b8eaf0826aa291970096da8.svg";
export { ForwardRef as ReactComponent };